import { createContext, useCallback, useContext, useMemo, useState } from "react";

const LoadingContext = createContext({
    setLoading: () => {},
    text: "",
    subText: "",
    display: false,
});

export function LoadingProvider({ children }) {
    const [display, setDisplay] = useState(false);
    const [text, setText] = useState("Loading...");
    const [subText, setSubText] = useState("");

    const setLoading = useCallback((loading, text, subText) => {
        if (!text) {
            text = "Loading...";
        }
        setDisplay(loading);
        setText(text);
        setSubText((subText || "").trim());
    }, []);

    const value = useMemo(
        () => ({
            setLoading,
            text,
            subText,
            display,
        }),
        [display, setLoading, subText, text],
    );
    return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
}

export function useLoading() {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error("useLoading must be used within LoadingProvider");
    }
    return context;
}

export default useLoading;
